import { useCreate } from '../../../../api/react-query';

export function useCreateLeaveRule() {
  const {
    mutateAsync: createLeaveRule,
    isLoading: isCreating,
    error,
  } = useCreate({
    url: 'engine/rule',
    apiVersion: 'v1',
    msg: 'Rule added successfully',
  });

  return {
    createLeaveRule,
    isCreating,
    error,
  };
}
